import { useEffect } from "react";
import { useWorkspaceActions } from "../lib/useWorkspaceActions";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { useWorkspace } from "../lib/useWorkspace";

export const WorkspaceRefresher: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { fetchDepartments, fetchUsers } = useWorkspaceActions()
  const { departments, setMyDepartments, setSubDepartments, setSubGenDepartments } = useWorkspace()
  const { isAuth, user } = useAuth()
  
  useEffect(() => {
    if (isAuth) {
      fetchUsers();
      fetchDepartments();
    }
    // eslint-disable-next-line
  },[isAuth])

  useEffect(() => {
    if (departments.length > 0 && user) {
      setMyDepartments(
        departments.filter(dep => user.bx.department.some(d => d.id === dep.id))
      )
    }
    // eslint-disable-next-line
  },[departments, user])

  useEffect(() => {
    if (departments.length > 0 && user) {
      setSubDepartments(
        departments.filter(dep => user.bx.department.some(d => d.id === dep.id && d.role === 'head'))
      )
    }
    // eslint-disable-next-line
  },[departments, user])

  useEffect(() => {
    if (departments.length > 0 && user) {
      setSubGenDepartments(
        departments.filter(dep => user.bx.department.some(d => (d.id === dep.id || d.id === dep.parent) && d.role === 'head'))
      )
    }
    // eslint-disable-next-line
  },[departments, user])

  return <>{children}</>;
}; 